// extracted by mini-css-extract-plugin
export default {"Arrow":"Arrow_Arrow__pcWcy","bounce":"Arrow_bounce__Hdrfj","swing-in":"Arrow_swing-in__PUqxX"};